import { useEffect, useState } from "react";
import { useStateValue } from "../../state";
import { Col, Form, Input, notification, Select } from "antd";
import api from "../../services/api";
import { listagemActions, manutencaoActions, selectPaginadoActions } from "../../actions";
import { SelectPaginacao } from "../../components";
import DrawerMarca from "../marca/drawer";
import DrawerTipoEquipamento from "../tipoEquipamento/drawer";

export default function ManutencaoModeloEquipamento({ formulario, carregando, aoSalvar, editando }) {


    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [fileList, setFileList] = useState([]);;
    const [openDrawerTipoEquipamento, setOpenDrawerTipoEquipamento] = useState(false);

    useEffect(() => {
        if (!!manutencao.dados) {
            let lista = [];
            if (!!manutencao.dados?.mar_id) {
                lista.push({ name: "mar_id", campo: "descricao_marca", value: manutencao.dados.mar_id });
            }
            if (!!manutencao.dados?.teq_id) {
                lista.push({ name: "teq_id", campo: "descricao_tipo", value: manutencao.dados.teq_id });
            }
        }
    }, [manutencao.dados]);


    const salvarManutencao = (values) => {
        carregando(true);
        let retorno;

        let enderecoUrl = 'ModeloEquipamento/';

        if (values.meq_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As novas configurações foram salvas com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    setFileList([]);
                })
        } else {
            enderecoUrl += `Incluir`;
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As configurações foram incluidas com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    dispatch({ type: listagemActions.CHANGE, data: { ordem: '+meq_id' } });
                }
            );
        }
    }

    function salvandoDadosTipo(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: "teq_id", campo: "CodigoTipo", value: retorno });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
        }
    }


    return (
        <Form layout="vertical" form={formulario} name="ManutencaoModeloEquipamento" onFinish={salvarManutencao}>
            <Form.Item name="meq_id" hidden={true}>
                <Input />
            </Form.Item>

            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Descrição do modelo do Equipamento" name="meq_descricao" rules={[{ required: true, message: "Informe a Descrição do Modelo" },]}>
                    <Input placeholder=" Ex: A11, A22..." />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Form.Item label="Tipo Equipamento" name="teq_id">
                    <SelectPaginacao url="TipoEquipamento/Listar"
                        allowClear={true}
                        selecionarRegUnico={"teq_id"}
                        nameLabel="teq_descricao"
                        nameValue="teq_id"
                        placeholder="Selecione o Tipo do Equipamento"
                        form={formulario}
                        funcaoIncluir={() => setOpenDrawerTipoEquipamento(true)}
                    />
                </Form.Item>
            </Col>
            {openDrawerTipoEquipamento && (
                <DrawerTipoEquipamento fecharSomenteDrawer={true} openDrawer={openDrawerTipoEquipamento} setOpenDrawer={setOpenDrawerTipoEquipamento} cadTipoEquipamento={false}
                    retornoSalvar={salvandoDadosTipo} />
            )}
        </Form>
    )
}